@import 'common/stylesheets/mixins/common.styl'

// The global reset strips list padding and markers; block-mode markdown needs both back.
.container
  :global(ul)
    padding-left 16px
  :global(ol)
    padding-left 28px
  :global(ul > li)
    list-style-type disc
  :global(ol > li)
    list-style-type decimal

  &.truncate
    truncate-text()
